'use client';

import { useLiveQuery } from '@sanity/preview-kit';
import { useContext, useEffect } from 'react';
import { pageByIdQuery } from './pageByIdQuery';
import { PageSections } from '@/components/layout';
import { PagePatternContext } from '@/components/layout/PagePattern';

interface Props {
  id: string;
}

export default function GenericPreviewPage({ id }: Props) {
  const { set: setPattern } = useContext(PagePatternContext);
  const [data] = useLiveQuery<(typeof pageByIdQuery)[1] | null>(
    null,
    pageByIdQuery[0],
    { id }
  );

  useEffect(() => {
    setPattern(data?.pattern ?? null);
  }, [data?.pattern]);

  return <PageSections isPreview sections={data?.sections ?? []} />;
}
